module.exports = __webpack_public_path__ + "static/media/downArrow.876a7e72.svg";